export enum EFeatureLimitItemsType {
  DEALS = "deals",
  AI_SUMMARIES = "AI summaries",
}
